import { UnknownAction } from 'redux'
import { ThunkAction } from 'redux-thunk'
import actionTypes from 'state/actionTypes'
import { IRootState } from 'types'
import { verifyTokenAction } from './userActions'
import { MenuRouteDto } from '@v1UsersApi'
import { V1ApiUsersClient } from 'core/http-common'

export const startLoadingAction = (): ThunkAction<void, IRootState, unknown, UnknownAction> => async dispatch => dispatch({ type: actionTypes.APP_LOADING_BAR_START })

export const endLoadingAction = (): ThunkAction<void, IRootState, unknown, UnknownAction> => async dispatch => dispatch({ type: actionTypes.APP_LOADING_BAR_END })

export const appResetAction = ()
    : ThunkAction<void, IRootState, unknown, UnknownAction> => async dispatch => dispatch({ type: actionTypes.APP_RESET })

export const appInitialize = ()
    : ThunkAction<void, IRootState, unknown, UnknownAction> => async (dispatch, getState) => {

        dispatch(startLoadingAction())
        dispatch({ type: actionTypes.APP_LOADED_START })

        if (location.pathname !== process.env.REACT_APP_LOGIN_REDIRECT) {
            await dispatch(verifyTokenAction())
            try {
                const routeResponse = await V1ApiUsersClient.getMenuRoutes()
                dispatch(setRoutes(routeResponse.data))
            }
            catch (e) { }
        }

        dispatch({ type: actionTypes.APP_LOADED_SUCCESS })
        dispatch(endLoadingAction())
    }

export const appLoadedSuccess = ()
    : ThunkAction<void, IRootState, unknown, UnknownAction> => async dispatch => dispatch({ type: actionTypes.APP_LOADED_SUCCESS })

export const setRoutes = (routes: Array<MenuRouteDto>)
    : ThunkAction<void, IRootState, unknown, UnknownAction> => async dispatch => dispatch({ type: actionTypes.APP_SET_ROUTES, payload: { routes } })
